import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import AllBookTemplate from "./AllBookTemplate";
import Search from "./Search";
import { backendBookartUrl } from "../library/constants";
import axios from "axios";

const BookLists = () => {
  const [state, setState] = useState({
    products: [],
    is_allBooks: false,
    cartUpdated: false,
    key: Date.now(),
    is_Search: false,
    loading: true,
    auth: false
  });

  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    getAllBooksDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllBooksDetails = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      search_value: 'all_products',
    });

    const config = {
      
      method: "post",
      url: `${backendBookartUrl}/allbooks?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: data,
    };

    try {
      const response = await axios(config);
      const products = response.data.products || [];
      setState((prevState) => ({
        ...prevState,
        products: products,
        is_allBooks: true,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching books:", error); // Log any errors
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }
  };

  const handleSearchCallback = (searchKeyword) => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    if (searchKeyword === ""){
      getAllBooksDetails()
    }
    else{
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      search_text: searchKeyword,
    });

    const config = {
      method: "post",
      url: `${backendBookartUrl}/search?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: data,
    };
    
    axios(config)
      .then((response) => {
        const products = response.data.products || [];
        setState((prevState) => ({
          ...prevState,
          products: products,
          is_allBooks: false,
          is_Search: true,
          loading: false,
        }));
        searchKeyword="";
      })
      .catch((error) => {
        console.log(error);
      });
    }
  };

  const clearSearch = () => {
    setState((prevState) => ({
      ...prevState,
      is_Search: false,
      loading: true // Set loading to true while fetching all books
    }));
    getAllBooksDetails(); // Fetch all books
  };

  const checkAndUpdatedCart = (flag) => {
    setState((prevState) => ({ ...prevState, cartUpdated: flag }));
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    //} else {
    //  const valid = await validateJWTtoken(token);
    //  if (!valid) {
    //   navigate("/");
     } else {
        setState((prevState) => ({ ...prevState, auth: true }));
      }
    //}
  };

  if (!state.auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
      <MainHeader cartUpdated={state.cartUpdated} />
      <section className="container">
      <Search callbackFunction={handleSearchCallback} />
      </section>
      <section className="container">
      <div className="search-results-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Book Lists</h3>
          {state.is_Search && (
            <button
            className="es-button small primary "
            type="button"
            onClick={clearSearch}
            style={{ marginLeft: "auto" }}

          >
            <span>Clear Search</span>
            {/* <svg
              focusable="false"
              height="16"
              viewBox="0 0 54 128"
              width="11"
            >
              <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
            </svg> */}
          </button>
          )}
        </div>
        {state.loading ? (
          <div className="es-progress-indicator" role="progressbar">
            <div></div>
          </div>
        ) : state.products.length === 0 ? (
          <p>No books available.</p>
        ) : (
          <AllBookTemplate
            key={state.is_Search ? state.key : state.products.length} // Use key to force re-render
            data={state.products} // Pass the products to AllBookTemplate
            is_allBooks={state.is_allBooks}
            checkAndUpdatedCart={checkAndUpdatedCart} // Ensure this prop is passed correctly
          />
        )}
      </section>
      <Footer />
    </React.Fragment>
    );
  }
};

export default BookLists;